<script setup lang="ts">
import { PropType } from 'vue';
import { Feature, PageName } from '@/api/tracking';
import AdpDocumentCard from '@/components/common/adp-document-card.vue';
import { AdpDocument, Comment } from '@/types/index';
import { useUserInfo } from '@/utils/swr';

defineProps({
  article: { type: Object as PropType<AdpDocument> },
  comment: { type: Object as PropType<Comment>, required: true },
  groupId: { type: Number, required: true },
  groupName: { type: String },
  showGroup: { type: Boolean, default: false },
  pageName: { type: String as PropType<PageName>, required: true },
  feature: String as PropType<Feature>,
  expandsAllChild: { type: Boolean, default: false },
  childDisplayCount: { type: Number, default: 2 },
});

const { data: userInfo } = useUserInfo();
</script>

<template>
  <div class="group-comment" v-if="comment && userInfo">
    <AdpDocumentCard
      width="100%"
      :adp-document="article"
      :theme-id="comment.theme_id"
      :comment="comment"
      :page-name="pageName"
      :feature="feature"
    ></AdpDocumentCard>
  </div>
</template>

<style lang="scss" scoped>
.group-comment {
  outline: none;
  background: #ffffff;
  border: 1px solid $color-gray400;
  box-sizing: border-box;
  border-radius: 4px;

  .router-link-exact-active {
    cursor: default;
  }

  .group {
    display: inline-block;
    vertical-align: bottom;
    .group-content {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      border-bottom: solid 1px white;
      .group-name {
        margin-left: 5px;
        font-weight: bold;
      }
      &:hover {
        border-color: $color-gray1000;
        cursor: pointer;
      }
    }
  }

  .article {
    margin-top: 12px;
  }

  .divider {
    margin-top: 12px;
    height: 1px;
    background: $color-gray400;
  }
  .reply {
    display: flex;
    justify-content: start;
    margin-top: 12px;
    .reply-button {
      width: 100%;
      margin-left: 8px;
      background: $color-gray200;
      border-radius: 8px;
      padding: 8px 12px;
      cursor: pointer;
      outline: none;
      .message {
        color: $color-gray600;
      }
    }
  }
  .replay-button-area {
    margin-left: 8px;
    .reply-button-small {
      width: 68px;
      height: 38px;
    }
  }
  .hint-text {
    margin: 2px 0 0 56px;
    color: $color-gray800;
  }
  .reply-textarea {
    margin-left: 8px;
  }

  .document-card {
    border: 0;
  }
}
</style>
